/**
 * 组件的emit事件声明
 * 基于方案设计文档生成
 * 该组件为纯展示组件，无交互事件
 */
export const emits = [
  // 无事件 - 纯展示组件
];
